/* eslint-disable no-unused-expressions */
import React, { useState } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import { TextField } from "formik-material-ui";
import { ToastContainer, toast } from "react-toastify";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import axios from "axios";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import { useNavigate } from "react-router-dom";

const theme = createTheme();

export default function ChangePassword() {
  const [loading, setLoading] = useState(false);
  const validateSignIn = Yup.object({
    password: Yup.string()
      .min(6, "Password must be at least 6 charaters")
      .required("Password is required"),
    newpassword: Yup.string()
      .min(6, "Password must be at least 6 charaters")
      .required("Password is required"),
    confirmpassword: Yup.string()
      .min(6, "Password must be at least 6 charaters")
      .required("Password is required"),
  });

  const [visible1Icon, setVisible1Icon] = React.useState(true);
  const [visible2Icon, setVisible2Icon] = React.useState(true);
  const [visible3Icon, setVisible3Icon] = React.useState(true);
  const navigate = useNavigate()

  const handleSubmit = (event) => {
    setLoading(true);
    axios
      .patch(`${process.env.REACT_APP_URL}/api/idp/v2/password`, 
        { password: event.password, newpassword: event.newpassword,},
        { headers : { Authorization: sessionStorage.getItem("token") } })
      .then((res) => {
        toast.success("Password successfully changed");
        navigate(-1);
        setLoading(false);
      })
      .catch((err) => {
        const message = (err?.response?.data?.errors && err?.response?.data?.errors[0]?.message) || "Something went wrong!";
        toast.error(message);
        setLoading(false);
      });
  };

  return (
    <ThemeProvider theme={theme}>
      <ToastContainer />
      <Container component="main" maxWidth="xs" className="py-5">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {/* <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
            <LockOutlinedIcon />
          </Avatar> */}
          <Typography component="h1" variant="h5">
            Change Password
          </Typography>

          <Formik
            initialValues={{ newpassword: "", confirmpassword: "", password: "" }}
            validationSchema={validateSignIn}
            onSubmit={async (values) => {
              handleSubmit(values);
              return new Promise((res) => setTimeout(res, 500));
            }}
          >
            {({ values, errors }) => (
              <Form autoComplete="off" className="mt-4">
                <Grid container spacing={2}>
                  <Grid item xs={12} className="input_div">
                    <Field
                      fullWidth
                      label="Password"
                      name="password"
                      component={TextField}
                      autoComplete="password"
                      type={visible1Icon ? "password" : "text"}
                    />
                    {visible1Icon ? (
                      <VisibilityOffIcon
                        onClick={() => setVisible1Icon((prev) => !prev)}
                      />
                    ) : (
                      <RemoveRedEyeIcon
                        onClick={() => setVisible1Icon((prev) => !prev)}
                      />
                    )}
                  </Grid>
                  <Grid item xs={12} className="input_div">
                    <Field
                      fullWidth
                      label="New Password"
                      name="newpassword"
                      component={TextField}
                      autoComplete="newpassword"
                      type={visible2Icon ? "password" : "text"}
                    />
                    {visible2Icon ? (
                      <VisibilityOffIcon
                        onClick={() => setVisible2Icon((prev) => !prev)}
                      />
                    ) : (
                      <RemoveRedEyeIcon
                        onClick={() => setVisible2Icon((prev) => !prev)}
                      />
                    )}
                  </Grid>
                  <Grid item xs={12} className="input_div">
                    <Field
                      fullWidth
                      label="Confirm Password"
                      name="confirmpassword"
                      component={TextField}
                      autoComplete="confirmpassword"
                      type={visible3Icon ? "password" : "text"}
                    />
                    {visible3Icon ? (
                      <VisibilityOffIcon
                        onClick={() => setVisible3Icon((prev) => !prev)}
                      />
                    ) : (
                      <RemoveRedEyeIcon
                        onClick={() => setVisible3Icon((prev) => !prev)}
                      />
                    )}
                  </Grid>
                </Grid>
                {loading ? (
                  <LoadingButton
                    loading
                    loadingPosition="start"
                    startIcon={<SaveIcon />}
                    variant="contained"
                    sx={{ mt: 2, mb: 2 }}
                    fullWidth
                  >
                    Submitting
                  </LoadingButton>
                ) : (
                  <Button
                    type="submit"
                    fullWidth
                    disabled={!values.password || !values.newpassword || !values.confirmpassword || values.newpassword !== values.confirmpassword}
                    className="mt-4"
                    variant="contained"
                    sx={{ mt: 2, mb: 2 }}
                  >
                    Submit
                  </Button>
                )}
              </Form>
            )}
          </Formik>
        </Box>
      </Container>
    </ThemeProvider>
  );
}